(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-hero-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const slider = document.getElementById("customHeroSlider");
  const slides = slider.querySelectorAll(".hero-slide");
  const dots = slider.querySelectorAll(".slider-dot");

  let current = 0;
  const total = slides.length;

  // Read speed from data attribute (added above)
  const speed = parseInt(slider.dataset.speed) * 1000;

  function showSlide(i) {
    slides.forEach((slide, idx) => {
      slide.style.display = idx === i ? "block" : "none";
    });

    dots.forEach((dot, idx) => {
      dot.classList.toggle("active", idx === i);
    });
  }

  showSlide(current);

  setInterval(() => {
    current = (current + 1) % total;
    showSlide(current);
  }, speed);

  dots.forEach(dot => {
    dot.addEventListener("click", () => {
      current = parseInt(dot.dataset.dot);
      showSlide(current);
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
